'use client'
import * as React from 'react';

var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgShield = function SvgShield(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4779FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.444 5.88a.833.833 0 0 1 1.112 0A9.13 9.13 0 0 0 21.14 8.2c.395-.02.75.24.848.624.226.87.345 1.782.345 2.721 0 5.05-3.453 9.29-8.125 10.492a.833.833 0 0 1-.416 0c-4.672-1.202-8.125-5.443-8.125-10.492 0-.939.12-1.85.345-2.722a.833.833 0 0 1 .849-.623 9.13 9.13 0 0 0 6.584-2.322Zm-5.96 3.999c-.099.54-.15 1.097-.15 1.667A9.171 9.171 0 0 0 14 20.368a9.171 9.171 0 0 0 6.516-10.49A10.788 10.788 0 0 1 14 7.587a10.788 10.788 0 0 1-6.515 2.293Zm9.605 1.912a.833.833 0 0 1 0 1.178l-3.333 3.333a.833.833 0 0 1-1.178 0l-1.667-1.666a.834.834 0 0 1 1.178-1.179l1.078 1.078 2.744-2.745a.833.833 0 0 1 1.178 0Z",
    fill: "#fff"
  })));
};

export { SvgShield as ReactComponent };
